import { createReducer } from "@reduxjs/toolkit";
import { defaultGetResponse } from "interfaces/ActionReducer/GetMethod/GetResponse";
import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { FeedbackStateInterface } from "actions/Feedback/types";
import {
    feedbackListReceived,
    feedbackOptionsReceived,
    feedbackTableFiltersReceived,
    getFeedbackList,
    getSegmentFeedbackComments,
    postSegmentFeedbackComment,
    segmentFeedbackCommentPosted,
    segmentFeedbackCommentsReceived,
    setFeedbackParams,
    setSelectedFeedbackColumns,
    setSelectedFeedbackIds,
    showFeedbackListView,
    toggleFeedbackActionPerformed
} from "actions";

const initialState: FeedbackStateInterface = {
    feedbackList: defaultGetResponse as any,
    feedbackOptions: { responder_type: [], response_category: [] },
    feedbackTableFilters: [],
    feedbackParams: { fields: "" },
    isFetchingFeedback: false,
    selectedColumns: [],
    selectedFeedbackIDs: [],
    showFeedbackListView: false,
    toggleFeedbackActionPerformed: false,
    segmentFeedbackComments: [],
    isFetchingSegmentFeedbackComments: false,
    isPostingSegmentFeedbackComment: false
};

const Feedback = createReducer(initialState, (builder) => {
    builder
        .addCase(showFeedbackListView, (state, action) => {
            state.showFeedbackListView = action.payload.showFeedbackListView;
        })
        .addCase(setFeedbackParams, (state, action) => {
            state.feedbackParams = action.payload.feedbackParams;
        })
        .addCase(getFeedbackList, (state) => {
            state.isFetchingFeedback = true;
        })
        .addCase(feedbackListReceived, (state, action) => {
            state.isFetchingFeedback = false;
            state.feedbackList = action.payload.feedbackList;
        })
        .addCase(feedbackOptionsReceived, (state, action) => {
            state.feedbackOptions = action.payload.feedbackOptions;
        })
        .addCase(feedbackTableFiltersReceived, (state, action) => {
            state.feedbackTableFilters = action.payload.feedbackTableFilters;
        })
        .addCase(setSelectedFeedbackIds, (state, action) => {
            state.selectedFeedbackIDs = action.payload.selectedFeedbackIDs;
        })
        .addCase(setSelectedFeedbackColumns, (state, action) => {
            state.selectedColumns = action.payload.selectedColumns;
        })
        .addCase(toggleFeedbackActionPerformed, (state) => {
            state.toggleFeedbackActionPerformed = !state.toggleFeedbackActionPerformed;
        })
        .addCase(getSegmentFeedbackComments, (state) => {
            state.isFetchingSegmentFeedbackComments = true;
            // Drop the previous thread's comments so they are not shown under a new thread
            state.segmentFeedbackComments = [];
        })
        .addCase(segmentFeedbackCommentsReceived, (state, action) => {
            state.isFetchingSegmentFeedbackComments = false;
            state.segmentFeedbackComments = action.payload.segmentFeedbackComments;
        })
        .addCase(postSegmentFeedbackComment, (state) => {
            state.isPostingSegmentFeedbackComment = true;
        })
        .addCase(segmentFeedbackCommentPosted, (state) => {
            state.isPostingSegmentFeedbackComment = false;
        })
        .addCase(resetStateRTK, () => initialState)
        .addDefaultCase((state) => state);
});

export default Feedback;
